import React from 'react';

const TextAreaWithSave = ({
  onSave,
  onKeyDown = undefined,
  className = '',
  ...props
}) => {
  /**
   * Triggers onSave for CMD + S (Mac) or Ctrl + S (Win)
   * or CMD + Enter (Mac) or Ctrl + Enter (Win) 
   * @param {event} event 
   */
  const handleKeyDown = (event) => {
    if ((event.key === 's' || event.key === 'S' || event.key === 'Enter'
      || event.keyCode === 83 || event.keyCode === 13)
      && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      onSave && onSave();
    }
    onKeyDown && onKeyDown(event);
  }
  return (
    <textarea
      {...props}
      className={`br-field__input ${className}`.trim()}
      onKeyDown={handleKeyDown}
    />
  )
}

export default TextAreaWithSave;
